import { defineBlock, smartProps } from '@smartfire/js-block-engine'
import style from './block.module.scss'
import EditableText from '@smartfire/components/editable-text'
import { EditableTextWithAniNum } from '@smartfire/components'

function Chiffre() {
    return (
        <div className={style.blockChiffre}>
            <EditableTextWithAniNum placeholder={'XX'} smartProp={'chiffre'} className={style.contentChiffre} />
            <EditableText tag={'p'} placeholder={'Insérez le texte'} smartProp={'text'} className={style.textChiffre} />
        </div>
    )
}

export default defineBlock({
    Block: Chiffre,
    smartProps: {
        chiffre: smartProps.string.withDefault(''),
        chiffreConfig: smartProps.object,
        text: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Chiffre',
        parent: ['smartfire/chiffres-cles'],
    },
})
